import { css } from '@emotion/react';
import styled from '@emotion/styled';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import { compose, position, space } from 'styled-system';

import { getKeyframeFrom } from '../../utils/style';
import Icon from '../Icon';

const StyledSpinner = styled(Icon)`
  ${({ theme }) => css`
    animation: ${getKeyframeFrom(theme.animations.rotate)} 1.5s linear infinite;
  `}
  ${compose(position, space)}
`;

function Spinner({ size, ...rest }) {
  return <StyledSpinner name="loading" size={size} {...rest} />;
}

Spinner.defaultProps = {
  size: 'size1',
};

Spinner.propTypes = {
  /**
   * Renders a spinner with a determined size
   */
  size: PropTypes.oneOf(['size1', 'size2', 'size3']),
  /**
   * Implements `styled-system` [space](https://styled-system.com/api/#space) utility
   */
  ...propTypes.space,
  /**
   * Implements `styled-system` [position](https://styled-system.com/api/#position) utility
   */
  ...propTypes.position,
};

export default Spinner;
